<button
  mat-icon-button
  aria-label="periodontal settings menu"
  [matMenuTriggerFor]="menu"
>
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="openPerioSettings()">
    <mat-icon>settings</mat-icon>
    <span>Periodontal Settings</span>
  </button>
  <button
    mat-menu-item
    [disabled]="immutable$ | async"
    (click)="deletePerioChartData()"
  >
    <mat-icon color="warn">delete</mat-icon>
    <span class="text-warn-500">Delete Chart</span>
  </button>
</mat-menu>
